import React, { useState,useEffect } from 'react';
import 'katex/dist/katex.min.css';
import katex from 'katex';
import { useTranslation } from 'react-i18next';
import { useSnackbar } from '../../SnackbarProvider';
import { requestUrl } from '../../requestUrl';
import LoadingData from '../dataloading';
import CustomButton from '../../components/CustomButton';
import { getColorDark,getColorLight ,getTheme} from '../../ColorManager';

import { Box,Card, CardContent, Typography, TextField, Button, IconButton,Grid } from "@mui/material";
import { ExpandMore, ExpandLess } from "@mui/icons-material";
import CodeMirror from "@uiw/react-codemirror";
import { oneDark } from '@codemirror/theme-one-dark';
import { javascript } from "@codemirror/lang-javascript";
import { cpp } from '@codemirror/lang-cpp'; // 导入 C++ 语言扩展
// 生成随机颜色函数
const getRandomColor = () => {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
};


const CodeVersionManage = () => {
  const showSnackbar = useSnackbar();
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [loadingText,setLoadingText] = useState('loading');
  const [userid,setUserid] = useState(0);
  const [colorManager, setColorManager] = useState(getColorDark()); // 初始化为空数组
  
  const [visibleIndex, setVisibleIndex] = useState(null);
  const [visibleIndices, setVisibleIndices] = useState([]);
  const toggleVisibility = (index) => {
    setVisibleIndices((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  const get_color_by_name = (name) => {

    const item = colorManager.find(item => item.container === name);
    return item.value;
  };


    const codeData = [
        {
          time: "2025-02-13 10:00:00",
          code: "#include <iostream>\nusing namespace std;\nint main() {\n    cout << \"Hello, World!\" << endl;\n    return 0;\n}",
          placeholder: "容器内容待填充"
        },
        {
          time: "2025-02-13 11:00:00",
          code: "def greet():\n    print(\"Hello, World!\")\n\ngreet()",
          placeholder: "占位符文本"
        },
        {
          time: "2025-02-13 12:00:00",
          code: "public class Main {\n    public static void main(String[] args) {\n        System.out.println(\"Hello, World!\");\n    }\n}",
          placeholder: "待填充区域"
        }
      ];


   useEffect(() => {
    const fetchData = async () => {
        try {
            setIsLoading(true);
            setLoadingText("loading");
            const dataToSend = {
                id:1,
            };
            const data = await requestUrl(dataToSend, "get_all_tags",t,showSnackbar);
            if(data.status === "success"){
               
              
            }
            
            
          } catch (error) {
              console.error("获取数据时出错:", error);
          } finally {
            setIsLoading(false);
          }
    };

    //fetchData(); 
  }, []);



    return (
        <div style={{ height: '100%', width:'100%', display: 'flex', flexDirection: 'column' ,backgroundColor:get_color_by_name('pop-window-bg'),}}>
            <Box sx={{ p: 3 }}>
      {codeData.map((item, index) => (
        <Card key={index} sx={{ mb: 2, p: 2, boxShadow: 3, cursor: "pointer" }} >
          <CardContent>
            <Typography variant="subtitle2" color="textSecondary">
              {item.time}
            </Typography>
            {/* 点击区域用于显示/隐藏 */}
            <Box sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={(e) => {
                e.stopPropagation();  // 防止点击事件冒泡
                toggleVisibility(index);
              }}>
                <Typography variant="h6" sx={{ flexGrow: 1 }}>
                  Code {index + 1}
                </Typography>
                {visibleIndices.includes(index) ? <ExpandLess /> : <ExpandMore />}
              </Box>
            {visibleIndices.includes(index) && (
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={6}>
                <CodeMirror
                      value={item.code}
                      options={{
                        mode: cpp(), // C++ 模式
                        theme: {oneDark}, // 使用 oneDark 主题
                        lineNumbers: true,
                        readOnly: true, // 设置为只读
                      }}
                      style={{ height: '300px', width: '100%' }}
                    />
                </Grid>
                <Grid item xs={2} display="flex" justifyContent="center" alignItems="center">
                  <Button variant="contained" color="primary">操作</Button>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="subtitle1">标题</Typography>
                  <Box sx={{ mt: 1, p: 2, bgcolor: "grey.100", borderRadius: 1 }}>
                    <Typography variant="body2" color="textSecondary">
                      {item.placeholder}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            )}
          </CardContent>
        </Card>
      ))}
    </Box>
        </div>
    )
};

export default CodeVersionManage;